import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import ReactMarkdown from 'react-markdown';
import Jumbotron from '../Jumbotron/Jumbotron.component';
import Description from '../Description/Description.component';
import Services from '../Services/Services.component';
import Contact from '../Contact/Contact.component';
import ClientLogos from '../ClientLogos/ClientLogos.component';
import background from '../../common_images/background2.jpg';
import backgroundDark from '../../common_images/backgroundDark2.jpg';
import tiresBackground from './images/tires.jpg';
import { getDescription, getSummary, getCooperation1, getCooperation2 } from '../../selectors/main';
import styles from './MainPage.stylesheet.css';

const MainPage = ({ description, summary, cooperation1, cooperation2 }) => (
	<section className={styles.MainPage}>
		<ClientLogos logoHeight={40} />
		<Element name="start">
			<Jumbotron />
		</Element>
		<Element name="about-us">
			<Description
				backgroundImg={background}
				heading={description.heading}
				text={description.text}
				bottomChildren={
					<div
            className={styles.widget}
						id="widgetDobryMechanik"
						style={{
							fontFamily: 'Arial',
							border: '1px solid #E8E8E8',
							padding: '5px',
							background: '#000',
							width: '200px',
							height: '510px'
						}}
					>
						<p
							style={{
								margin: 0,
								fontWeight: 'bold',
								padding: '10px',
								borderBottom: '1px solid #3B3B3B'
							}}
						>
							<a
								rel="nofollow"
								target="_blank"
								href="https://dobrymechanik.pl/"
								title="DobryMechanik.pl"
								style={{ color: '#fff', textDecoration: 'none', fontSize: '11px' }}
							>
								Jesteśmy w <b style={{ color: '#176AE6', textDecoration: 'none' }}>DobryMechanik.pl</b>
							</a>
						</p>
						<iframe
							width="190px"
							src="https://dobrymechanik.pl/widgets/get/id:12314/color:black/width:200/hash:63b51ed6fce6a9c410cb9f35f0d03bee09b85311"
							style={{ border: '0px', height: '420px', overflow: 'hidden' }}
						/>
						<a
							rel="nofollow"
							target="_blank"
							href="https://dobrymechanik.pl/mechanicy/zobacz/12314"
							style={{
								color: '#176AE6',
								fontWeight: 'bold',
								textDecoration: 'none',
								position: 'absolute',
								bottom: '5px',
								right: '5px',
								fontSize: '10px'
							}}
						>
							{' '}
							nasz warsztat w DobryMechanik.pl »
						</a>
					</div>
				}
			/>
		</Element>
		<Element name="offer">
			<Services />
		</Element>
		<Element name="cooperation">
			<Description
				backgroundImg={backgroundDark}
				heading={cooperation2.heading}
				text={cooperation2.text}
				isDark={true}
			/>
		</Element>
		<Element name="jobs">
			<div
				className={styles.lastSectionsWrapper}
				style={{ background: `url(${tiresBackground}) center center / cover fixed` }}
			>
				<div className={styles.descriptionBackground} />
				<Description heading={cooperation1.heading} isDark={true}>
					<div style={{ textAlign: 'center' }}>
						<ReactMarkdown source={cooperation1.text} />
					</div>
					<ReactMarkdown source={cooperation1.text2} />
				</Description>
				<Description isDark={true}>
					<div style={{ textAlign: 'center' }}>
						<ReactMarkdown source={cooperation1.text3} />
					</div>
					<ReactMarkdown source={cooperation1.text4} />
					<div style={{ textAlign: 'center' }}>
						<ReactMarkdown source={cooperation1.text5} />
					</div>
				</Description>
				<div className={styles.contactBackground} />
			</div>
		</Element>
		<Element name="contact">
			<Contact />
		</Element>
	</section>
);

const mapStateToProps = (state) => {
	return {
		description: getDescription(state),
		summary: getSummary(state),
		cooperation1: getCooperation1(state),
		cooperation2: getCooperation2(state)
	};
};

MainPage.propTypes = {
	description: PropTypes.object,
	summary: PropTypes.object
};

export default connect(mapStateToProps)(MainPage);



// WEBPACK FOOTER //
// ./src/components/MainPage/MainPage.component.js